export const money = (n) => `£${Number(n || 0).toFixed(2)}`;
